













import {Component, Prop, Vue} from 'vue-property-decorator';
/**
 * @status stable
 * @changelog 6.7.0 Added click event, changed colours and size
 */
@Component
export default class JdsPipelineCardDrawer extends Vue {
    @Prop() icon!: string
    @Prop({default: 'neutral'}) state!: 'neutral'|'pass'|'warn'|'fail'

    get classes() {
        return {
            'jdsc-pipeline-card-drawer-contents--neutral': this.state === 'neutral',
            'jdsc-pipeline-card-drawer-contents--pass': this.state === 'pass',
            'jdsc-pipeline-card-drawer-contents--warn': this.state === 'warn',
            'jdsc-pipeline-card-drawer-contents--fail': this.state === 'fail',
        }
    }

    handleClick() {
        this.$emit('click');
    }
}
